import { render, staticRenderFns } from "./GoogleIndexing.vue?vue&type=template&id=791ba924&scoped=true&"
import script from "./GoogleIndexing.vue?vue&type=script&lang=js&"
export * from "./GoogleIndexing.vue?vue&type=script&lang=js&"
import style0 from "./GoogleIndexing.vue?vue&type=style&index=0&id=791ba924&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791ba924",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VChipGroup,VCol,VMenu,VRow})
